import React from 'react';
import moment from 'moment';
import Spoiler from '~c/ui/Spoiler';

// Routing
import routes from '~/apiRouter';

import { EducationData } from './Forms/EducationData';
import { isUserEducationDataFilled } from './Forms/EducationData/utils';

import { getCityNameByKLADR } from '~h/cityCodes';
import { FormMessage } from '../../../components/FormMessage';
import OrderedTab from './OrderedTab';
import { getSingleDate } from '../../../helpers/calendar';
import Loader from '~/components/ui/Loader';

/*
  TODO: нужна инфа о потоке, продолжительности курса, ссылка на аватар, ссылка на оплату
 */

class OrderedCoursesTab extends React.Component {
  state = {
    courses: [],
    loading: true,
    errors: [],
  };

  componentDidMount() {
    this.getData();
  }

  /**
   *
   * @param dateString - date in DD-MM-YYYY HH:mm:ss format
   * @return {Date}
   */
  parseDate(dateString) {
    if (!dateString) return null;
    const trimmedDateString = dateString.slice(0, 10);
    return moment(trimmedDateString, 'DD-MM-YYYY').toDate();
  }

  // FIXME: need refactor
  getData = () => {
    // Statuses regforms
    // {"Code":"1","Name":"Активная"}
    // {"Code":"176660000","Name":"Отмененная"}
    // {"Code":"2","Name":"Обработанная"}

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };
    const url = routes.user.regforms;

    fetch(url, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {

        if (!response.data.REGISTRATION_FORMS) {
          return this.setState({ courses: [], loading: false });
        }
        const rawData = response.data.REGISTRATION_FORMS.filter(
          rf => rf.STATUS !== '176660000',
        ); // filter canceled regforms

        const eventList = rawData
          .map(regForm => regForm.ORDER_PRODUCTS ? regForm.ORDER_PRODUCTS.EVENT_CODE : null)
          .filter(el => el !== null);
        const uniqueEvents = new Set(eventList);

        const courses = Array.from(uniqueEvents).map(eventCode => {
          const regFormsRaw = rawData.filter(
            form => !!form.ORDER_PRODUCTS && form.ORDER_PRODUCTS.EVENT_CODE === eventCode,
          );

          const event = regFormsRaw[0].ORDER_PRODUCTS.EVENT;
          const formType = regFormsRaw[0].ORDER_PRODUCTS.FORM_TYPE;
          const offerLink = regFormsRaw[0].ORDER_PRODUCTS.EVENT.MERCHANT;
          const linkedEvents = [
            {
              code: regFormsRaw[0].ORDER_PRODUCTS.EVENT.CODE,
              page: regFormsRaw[0].ORDER_PRODUCTS.EVENT?.PAGE?.DETAIL_PAGE_URL,
              name: regFormsRaw[0].ORDER_PRODUCTS.EVENT.SHORT_NAME,

              city: getCityNameByKLADR(regFormsRaw[0].ORDER_PRODUCTS.EVENT.CITY_CODE),
              dates: getSingleDate(
                regFormsRaw[0].ORDER_PRODUCTS.EVENT.START_DATE,
                regFormsRaw[0].ORDER_PRODUCTS.EVENT.END_DATE,
                regFormsRaw[0].ORDER_PRODUCTS.EVENT.EVENT_DAYS,
              ),
            },
          ];

          const listeners = regFormsRaw.map(regForm => {
            return {
              isForEntity: regForm.ACCESS_TO_COMPANY,
              price: parseFloat(regForm.RF_TOTAL_AMOUNT),
              isPaid: regForm.ORDER.IS_PAID,
              isCanceled: regForm.ORDER.IS_CANCELED,
              canPay: regForm.IS_PAYMENT_PERMITTED,
              dateCreated: regForm.DATE_CREATED,
              isButtonDisabled: false,
              rfid: regForm.RF_ID,
              personalData: {
                fullName: regForm.STUDENT_FULL_NAME,
                id: regForm.STUDENT_ID,
              },
              offerLink,
            };
          });

          return {
            code: eventCode,
            eventName: event?.SHORT_NAME,
            formType,
            city: getCityNameByKLADR(event?.CITY_CODE),
            linkedEvents,
            startDate: moment(event?.START_DATE, 'DD-MM-YYYY HH:mm:ss').toDate(),
            endDate: moment(event?.END_DATE, 'DD-MM-YYYY HH:mm:ss').toDate(),
            days: this.getEventDays(event?.EVENT_DAYS),
            listeners,
          };
        });

        this.setState({ courses });
        } else {
          this.setState({ errors: response.errors.map(error => error.message) });
        }

        this.setState({
          loading: false,
        });
      })
      .catch(error => {
        this.setState({
          errors: [error.message],
          loading: false,
        });
      });
  };

  getNames(string) {
    if (!string) return [];
    const names = string.split(' ');

    switch (names.length) {
    case 2:
    {
      const firstname = names[0];
      const lastname = names[1];
      return [lastname, firstname];
    }
    case 3:
    {
      const firstname = names[0];
      const patronymic = names[1];
      const lastname = names[2];
      return [lastname, firstname, patronymic];
    }
    default:
      return [];
    }
  }

  getStudent(id) {
    return window.user?.CONTACT_ID?.toLowerCase() === id?.toLowerCase()
      ? window.user
      : window.user?.CONTACTS.find(
        contact => contact.CONTACT_ID?.toLowerCase() === id?.toLowerCase(),
      );
  }

  /**
   *
   * @param {array} days - array of objects {START_DATE:..., END_DATE: ...}
   * @return {array} of Date objects
   */
  getEventDays(days) {
    if (!days?.length) return [];

    return days.map(day => {
      const startDate = moment(day.START_DATE, 'DD-MM-YYYY HH:mm:ss').toDate();
      const endDate = moment(day.END_DATE, 'DD-MM-YYYY HH:mm:ss').toDate();
      const durationMs = endDate - startDate;

      return {
        startDate,
        endDate,
        durationMs,
      };
    });
  }

  getContentByType(type) {
    switch (type) {
    case 'EDU':
      if (!isUserEducationDataFilled) return <EducationData
        setButtonDisabled={(val) => this.setState({ isButtonDisabled: val })}/>;
    }
  }

  render() {
    const { courses, errors, loading } = this.state;

    if (loading) {
      return (
        <React.Fragment>
          <div
            className="banner-action__warnings-container"
          >
            <Loader/>
          </div>
        </React.Fragment>
      );
    }

    if (!!errors.length) {
      return (
        <React.Fragment>
          <div
            className="banner-action__warnings-container"
          >
            {errors.map((error, index) => {
              return (
                <span
                  key={index}
                  className="banner-action__error"
                >{error}</span>
              );
            })}
          </div>
        </React.Fragment>
      );
    }

    const changeStatePaymentButton = (newState, listenerId) => {
      const newCourses = this.state.courses.map((course) => {
        return {
          ...course,
          listeners: course.listeners.map((listener) => {
            if (listener.personalData.id === listenerId && course.formType === 'EDU') {
              return {
                ...listener,
                isButtonDisabled: newState,
              };
            }
            return listener;
          }),
        };
      });

      this.setState({ courses: newCourses });
    };

    const coursesStr = courses.map((course) => {
      const studentBannerStr = course.listeners.map((listener, index) => {
        const [rawLastname, rawFirstname, rawPatronymic] = this.getNames(
          listener.personalData.fullName,
        );

        const studentData = this.getStudent(listener.personalData.id);
        const firstname = studentData?.FIRST_NAME || rawFirstname || ' ';
        const lastname = studentData?.LAST_NAME || rawLastname || ' ';
        const patronymic = studentData?.MIDDLE_NAME || rawPatronymic || ' ';
        const job = studentData?.JOB_TITLE || ' ';
        const studentPhoto = studentData?.SITE?.PERSONAL_PHOTO?.SRC;

        const { id } = listener.personalData;
        const snils = studentData?.SNILS;
        const diplomaRegNumber = studentData?.DIPLOMA_REG_NUMBER;
        const diplomaQualification = studentData?.DIPLOMA_QUALIFICATION;
        const diplomaSeries = studentData?.DIPLOMA_SERIES;
        const diplomaNumber = studentData?.DIPLOMA_NUMBER;

        // give 5min timeout
        const processTimeout = 5 * 60 * 1000;

        const isInProcess =
          listener.dateCreated &&
          Date.now() -
          moment(listener.dateCreated, 'DD.MM.YYYY HH:mm:ss Z').valueOf() <
          processTimeout;

        const filteredEvents = !!course.linkedEvents.length ? [course.linkedEvents[0]] : [];
        const linkedEventsStr = filteredEvents.map(event => {
          return (
            <div
              className="banner-action__param banner-action__param--block title"
              key={`key_${event.name}`}
            >
              <a href={event.page}>{event.name}</a>
              <p className="txt banner-action__dates ">
                {event.city && event.dates ? (
                  `${event.city}`
                ) : (
                  <span className="online-badge online-badge--yellow" style={{ marginRight: '10px' }}/>
                )}
                <span className="txt txt--inline-block">
                  {event.dates ? `, ${event.dates}` : 'В любое время'}
                </span>
              </p>
            </div>
          );
        });

        return (
          <React.Fragment key={`spoiler_${index + 1}`}>
            <EducationData
              formType={course.formType}
              studentData={studentData}
              canPay={listener.canPay}
              studentId={id}
              lastname={lastname}
              firstname={firstname}
              dataForEduServices={{ snils, diplomaRegNumber, diplomaQualification, diplomaSeries, diplomaNumber }}
              setButtonDisabled={changeStatePaymentButton}
            />
            <div className="banner-action banner-action--spoiler">
              <div className="banner-action__wrap">
                <div className="banner-action__detail">
                  <div className="member member--profile">
                    {studentPhoto ? (
                      <div
                        className="member__img member__img--profile"
                        style={{ backgroundImage: `url(${studentPhoto})` }}
                      />
                    ) : (
                      <div
                        className="member__img member__img--profile"
                        data-letter={lastname[0]}
                      />
                    )}
                    <div className="member__inner">
                      <p className="member__name">
                        {lastname}&nbsp;
                        {firstname !== ' ' ? `${firstname[0]}.` : null}&nbsp;
                        {patronymic !== ' ' ? `${patronymic[0]}.` : null}
                      </p>
                      {/* TODO: member job is not defined in window.user */}
                      <p className="member__post">{job}</p>
                    </div>
                  </div>
                  <div className="banner-action__info">{linkedEventsStr}</div>
                </div>
                <div className="banner-action__action">
                  {isInProcess ? (
                    <React.Fragment>
                      <p className="banner-action__param title">
                        Заказ обрабатывается
                      </p>
                      <p className="banner-action__param">
                        Информация об оплате будет доступна в течение 5{'\u00A0'}
                        минут
                      </p>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <p className="banner-action__param title">Стоимость</p>
                      <OrderedTab listener={listener}/>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      });

      const numberEmptyFields = course.listeners.reduce((stateFilled, listener) => {
        const studentData = this.getStudent(listener.personalData.id);
        if (!studentData) {
          return stateFilled;
        }
        const { SNILS, DIPLOMA_REG_NUMBER, DIPLOMA_QUALIFICATION, DIPLOMA_SERIES, DIPLOMA_NUMBER } = studentData;
        if (!(SNILS && DIPLOMA_REG_NUMBER && DIPLOMA_QUALIFICATION && DIPLOMA_SERIES && DIPLOMA_NUMBER)) {
          return stateFilled + 1;
        }
        return stateFilled;
      }, 0);

      const courseStr = (
        <section className="banner-action-wrapper spoiler__block">
          {numberEmptyFields > 0 && course.formType === 'EDU' && (
            <FormMessage style={{ marginBottom: '40px' }} extraClass="error">
              Пожалуйста, заполните поля, необходимые для оплаты. Все поля <b>обязательны</b> для оплаты,
              оформления договора и выдаче сертификата о дополнительном образовании.
            </FormMessage>
          )}
          {studentBannerStr}
        </section>
      );

      const coursePaid = course.listeners.every(listener => listener.isPaid);

      const headerStr = coursePaid ? (
        <p className="title">
          {course.eventName}{' '}
          <ul className="tags tags--yellow tags--sm">
            <li className="tag">Оплачен</li>
          </ul>
        </p>
      ) : (
        <p className="title">{course.eventName}</p>
      );

      return (
        <Spoiler key={course.code} header={headerStr} content={courseStr}/>
      );
    });

    return (
      <React.Fragment>
        {coursesStr.length ? (
          <div className="spoilers"> {coursesStr} </div>
        ) : (
          <div
            className="banner-action__warnings-container"
          >
            <span
              className="banner-action__notice"
            >Здесь будут отображаться ваши заказы</span>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default OrderedCoursesTab;
